"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTequila = exports.isIos = exports.isAndroid = exports.getPlatform = void 0;
var _consts = require("./consts");
const getPlatform = _ref => {
  let {
    ui
  } = _ref;
  if (ui != null && (ui === _consts.UICookiePrefix.ANDROID || ui.startsWith(`${_consts.UICookiePrefix.ANDROID}_`))) {
    return _consts.Platform.ANDROID;
  } else if (ui != null && (ui === _consts.UICookiePrefix.IOS || ui.startsWith(`${_consts.UICookiePrefix.IOS}_`))) {
    return _consts.Platform.IOS;
  } else if (ui != null && (ui === _consts.UICookiePrefix.TEQUILA || ui.startsWith(`${_consts.UICookiePrefix.TEQUILA}_`))) {
    return _consts.Platform.TEQUILA;
  }
  return _consts.Platform.WEB;
};
exports.getPlatform = getPlatform;
const isIos = _ref2 => {
  let {
    ui
  } = _ref2;
  return ui != null && (ui === _consts.UICookiePrefix.IOS || ui.startsWith(`${_consts.UICookiePrefix.IOS}_`));
};
exports.isIos = isIos;
const isAndroid = _ref3 => {
  let {
    ui
  } = _ref3;
  return ui != null && (ui === _consts.UICookiePrefix.ANDROID || ui.startsWith(`${_consts.UICookiePrefix.ANDROID}_`));
};
exports.isAndroid = isAndroid;
const isTequila = _ref4 => {
  let {
    ui
  } = _ref4;
  return ui != null && (ui === _consts.UICookiePrefix.TEQUILA || ui.startsWith(`${_consts.UICookiePrefix.TEQUILA}_`));
};
exports.isTequila = isTequila;